// extracted by mini-css-extract-plugin
export default {"root":"SubjBl_root__DBMgk","inner":"SubjBl_inner__KfLGL","subject":"SubjBl_subject__2V9Hv","grade":"SubjBl_grade__Q7nsT"};